import type { LayoutType } from 'types';
import type { TemplateFormsState } from '../index';

export interface Payload {
  name: string;
  layoutType: LayoutType;
}

export const removeSection = (state: TemplateFormsState, { payload }: { payload: Payload }) => {
  const { name, layoutType } = payload;
  const sections = state[layoutType].sections;

  if (sections.length === 1) {
    return;
  }

  state[layoutType].sections = sections.filter((section) => section.name !== name);
};
